export const ENVIRONMENT_LOCAL = "localhost";
export const ENVIRONMENT_TEST = "edna-frontend-test.uoc.edu";
export const ENVIRONMENT_PRE = "edna-frontend-pre.uoc.edu";
export const ENVIRONMENT_PRO = "edna-frontend.uoc.edu";